import React, { useState } from 'react';

import RequestService from "../../services/request.service";

import AuthService from '../../features/auth/auth.service'

import { Button, Modal } from 'react-bootstrap';

import { toast } from 'react-toastify'


const ModalEstructuraPagosEstrategias = ( params : any ) => {

  const user = AuthService.getCurrentUser()

  const { show, handleClose, sucursal_seleccionada } = params

  const [ matrices_comisiones, setMatrices_comisiones ] = useState<any>([])
  const [ envio_server, setSeEnvio ] = useState<boolean>(false)
  const cargarMatrices_comisiones = async()=>{
    try{
      setSeEnvio(true)
      let response : any = await RequestService.getEndPoint(`sucursal/comisiones/matrices/${sucursal_seleccionada.uuid}`)
      setMatrices_comisiones(response.data)
      setSeEnvio(false)
    }
    catch(e){
      setSeEnvio(false)
      toast.error('Problemas al intentar cargar')
    }
  }


  React.useEffect(() => {
    cargarMatrices_comisiones()
  }, []);






  return (
    <>
      <Modal show={show} size="xl" onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Estructura de Pagos </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <small>Sucursales</small>
          <h3>{sucursal_seleccionada.nombre_sucursal}</h3>

          {
            // JSON.stringify(sucursal_seleccionada)
          }
          
          {
            JSON.stringify(matrices_comisiones)
          }

        </Modal.Body>
      </Modal>
    </>
  );
}


export default ModalEstructuraPagosEstrategias;